module.exports = __webpack_public_path__ + "static/media/world.35e57dab.png";